module.exports = __webpack_public_path__ + "static/media/bimkeeper-logo-beeldmerk.f22e6822.svg";